<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="700px">
    <template v-slot:title>Update Pax</template>
    <v-container v-if="accommodationSettings.length > 0">
      <h6 class="subtitle-2">ACCOMMODATION:</h6>
      <v-row v-for="roomType in accommodationSettings" :key="roomType.id">
        <v-col cols="6">
          <v-text-field
            type="number"
            :label="roomType.label"
            v-model.number="roomType.qty"
            :min="roomType.min"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Adults"
            v-model.number="roomType.adults"
            @change="onPaxChange(roomType)"
            :max="maxAdults"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Children"
            v-model.number="roomType.children"
            @change="onPaxChange(roomType)"
            :max="maxChildren"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
        <v-col xs2>
          <v-text-field
            type="number"
            label="Infants"
            v-model.number="roomType.infants"
            @change="onPaxChange(roomType)"
            :max="maxInfants"
            min="0"
            :outlined="outlinedInputs"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6" class="text-right py-0">
          <h3>Total:</h3>
        </v-col>
        <v-col class="py-0">{{ totals.adults }}</v-col>
        <v-col class="py-0">{{ totals.children }}</v-col>
        <v-col class="py-0">{{ totals.infants }}</v-col>
      </v-row>
    </v-container>
    <v-divider></v-divider>
    <v-container
      v-if="
        extrasSettings.filter((e) => e.serviceType == 'ACCOMMODATION').length >
        0
      "
    >
      <h6 class="subtitle-2">ACCOMMODATION EXTRAS:</h6>
      <v-row
        v-for="extra in extrasSettings.filter(
          (e) => e.serviceType == 'ACCOMMODATION'
        )"
        :key="extra.id"
      >
        <v-col cols="10">
          <h4>{{ extra.label }}</h4>
        </v-col>
        <v-col class="py-0">
          <v-text-field
            label="Qty"
            type="number"
            v-model.number="extra.qty"
            :min="0"
            :outlined="outlinedInputs"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container v-for="otherType in otherTypesSettings" :key="otherType.id">
      <h6 class="subtitle-2">{{ otherType.label }}:</h6>
      <v-row>
        <v-col>
          <v-text-field
            type="number"
            label="Adults"
            v-model.number="otherType.adults"
            min="0"
            :max="maxAdults"
            @change="ensureCorrectPax(otherType)"
            :outlined="outlinedInputs"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            type="number"
            label="Children"
            :max="maxChildren"
            v-model.number="otherType.children"
            min="0"
            :outlined="outlinedInputs"
            @change="ensureCorrectPax(otherType)"
            hide-details
          ></v-text-field>
        </v-col>
        <v-col>
          <v-text-field
            type="number"
            label="Infants"
            v-model.number="otherType.infants"
            min="0"
            :max="maxInfants"
            :outlined="outlinedInputs"
            @change="ensureCorrectPax(otherType)"
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <template
        v-if="
          extrasSettings.filter((e) => e.serviceType == otherType.type).length >
          0
        "
      >
        <h6 class="subtitle-2">EXTRAS:</h6>
        <v-row
          v-for="extra in extrasSettings.filter(
            (e) => e.serviceType == otherType.type
          )"
          :key="extra.id"
        >
          <v-col cols="10">
            <h4>{{ extra.label }}</h4>
          </v-col>
          <v-col class="py-0">
            <v-text-field
              label="Qty"
              type="number"
              v-model.number="extra.qty"
              :min="0"
              :outlined="outlinedInputs"
            />
          </v-col>
        </v-row>
      </template>
    </v-container>
    <div v-if="debug">
      <code>{{ extrasSettings }}</code>
    </div>

    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onUpdate"
        >Update</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../../shared/BasicDialog";
var randomize = require("randomatic");
export default {
  name: "pax-update-dialog",

  props: {
    headerProps: {
      type: Object,
      default: () => null,
    },
    show: {
      type: Boolean,
      default: () => false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    skipLimit: {
      type: Boolean,
      default: () => true,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      debug: false,
      maxAdults: this.skipLimit
        ? 99
        : this.headerProps && this.headerProps.adults
        ? this.headerProps.adults
        : 99,
      maxInfants: this.skipLimit
        ? 99
        : this.headerProps && this.headerProps.infants
        ? this.headerProps.infants
        : 99,
      maxChildren: this.skipLimit
        ? 99
        : this.headerProps && this.headerProps.children
        ? this.headerProps.children
        : 99,
      roomTypes: [
        {
          id: randomize("Aa0", 32),
          label: "Single Occupancy Rooms",
          occupancy: 1,
          min: 0,
          qty: "",
          adults: 0,
          children: 0,
          infants: 0,
        },
        {
          id: randomize("Aa0", 32),
          label: "Twin/Double Rooms",
          occupancy: 2,
          min: 0,
          qty: "",
          adults: 0,
          children: 0,
          infants: 0,
        },
        {
          id: randomize("Aa0", 32),
          label: "Triple Rooms",
          occupancy: 3,
          min: 0,
          qty: "",
          adults: 0,
          children: 0,
          infants: 0,
        },
        {
          id: randomize("Aa0", 32),
          label: "Quadruple(4+) Rooms",
          occupancy: 4,
          min: 0,
          qty: "",
          adults: 0,
          children: 0,
          infants: 0,
        },
        {
          id: randomize("Aa0", 32),
          label: "Multi Bed Rooms",
          occupancy: 100,
          min: 0,
          qty: "",
          adults: 0,
          children: 0,
          infants: 0,
        },
      ],
      otherTypes: [
        {
          id: randomize("Aa0", 32),
          label: "TRANSPORT",
          adults: 0,
          children: 0,
          infants: 0,
          type: "TRANSPORT",
        },
        {
          id: randomize("Aa0", 32),
          label: "ACTIVITY",
          adults: 0,
          children: 0,
          infants: 0,
          type: "ACTIVITY",
        },
        {
          id: randomize("Aa0", 32),
          label: "TRAVEL",
          adults: 0,
          children: 0,
          infants: 0,
          type: "TRAVEL",
        },
        {
          id: randomize("Aa0", 32),
          label: "OTHER",
          adults: 0,
          children: 0,
          infants: 0,
          type: "OTHER",
        },
        {
          id: randomize("Aa0", 32),
          label: "ITINERARY CHARGES",
          adults: 0,
          children: 0,
          infants: 0,
          type: "MANDATORY_CHARGES",
        },
        {
          id: randomize("Aa0", 32),
          label: "PACKAGE",
          adults: 0,
          children: 0,
          infants: 0,
          type: "PACKAGE",
        },
      ],
      extrasSettings: this.items.reduce((extras, item) => {
        if (item.extras && item.extras.length > 0) {
          for (const e of item.extras.filter((e) => e.rateBase == "I")) {
            extras.push({
              id: e.id,
              label: `${e.name} (${item.serviceName})`,
              qty: 0,
              serviceType: item.serviceType,
            });
          }
        }
        return extras;
      }, []),
    };
  },

  computed: {
    isValid() {
      for (const stng of [
        ...this.accommodationSettings,
        ...this.otherTypesSettings,
      ]) {
        if (
          Number(stng.adults) + Number(stng.children) + Number(stng.infants) >
          0
        ) {
          return true;
        }
      }
      return false;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    accommodationSettings() {
      const accommodationServices = this.items
        .filter((item) => item.serviceType == "ACCOMMODATION")
        .map((item) => item.stdOccupancy);
      return [
        ...this.roomTypes.filter(
          (rt) => accommodationServices.indexOf(rt.occupancy) > -1
        ),
      ];
    },

    otherTypesSettings() {
      const otherServicesTypes = [
        ...new Set(
          this.items
            .filter((item) => item.serviceType != "ACCOMMODATION")
            .map((item) => item.serviceType)
        ),
      ];
      return this.otherTypes.filter(
        (ot) => otherServicesTypes.indexOf(ot.type) > -1
      );
    },
    totals() {
      const totals = this.roomTypes.reduce(
        (t, roomType) => {
          t.adults = Number(t.adults) + Number(roomType.adults);
          t.children = Number(t.children) + Number(roomType.children);
          t.infants = Number(t.infants) + Number(roomType.infants);
          return t;
        },
        { adults: 0, children: 0, infants: 0 }
      );
      //include other types totals - when there's no accommodation
      if (this.accommodationSettings.length == 0) {
        for (const ots of this.otherTypesSettings) {
          totals.adults = Number(totals.adults) + Number(ots.adults);
          totals.children = Number(totals.children) + Number(ots.children);
          totals.infants = Number(totals.infants) + Number(ots.infants);
        }
      }
      return totals;
    },
  },
  watch: {
    headerProps(newProps) {
      if (!this.skipLimit) {
        this.maxAdults = newProps.adults;
        this.maxChildren = newProps.children;
        this.maxInfants = newProps.infants;
      } else {
        this.maxAdults = 99;
        this.maxChildren = 99;
        this.maxInfants = 99;
      }
    },
    items(newItems) {
      this.extrasSettings = newItems.reduce((extras, item) => {
        if (item.extras && item.extras.length > 0) {
          for (const e of item.extras.filter((e) => e.rateBase == "I")) {
            extras.push({
              id: e.id,
              label: `${e.name} (${item.serviceName})`,
              qty: 0,
              serviceType: item.serviceType,
            });
          }
        }
        return extras;
      }, []);
    },
  },
  methods: {
    onUpdate() {
      this.$emit("update", {
        accommodationSettings: this.accommodationSettings,
        otherTypesSettings: this.otherTypesSettings,
        extrasSettings: this.extrasSettings,
        totals: { ...this.totals },
      });
    },
    ensureCorrectPax(service) {
      if (service.adults > this.maxAdults) service.adults = this.maxAdults;
      if (service.children > this.maxChildren)
        service.children = this.maxChildren;
      if (service.infants > this.maxInfants) service.infants = this.maxInfants;
    },
    onPaxChange(roomType) {
      if (this.headerProps != null) {
        this.ensureCorrectPax(roomType);
      }
      const pax = Number(roomType.adults) + Number(roomType.children);
      roomType.qty = Math.ceil(pax / roomType.occupancy);
      roomType.min = Math.ceil(pax / roomType.occupancy);
      for (const ots of this.otherTypesSettings) {
        ots.adults = this.totals.adults;
        ots.children = this.totals.children;
        ots.infants = this.totals.infants;
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/tools/PaxUpdateDialog.vue